import { Modal, Notification, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import { useTranslation, Trans } from 'react-i18next';

import * as S from './style';

function ShipmentTypeGptModal({ isOpen, setIsOpen }) {
  const { t } = useTranslation();

  const shipmentTypeGptList = t('shipmentTypeGptList', { returnObjects: true });

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={setIsOpen}
      primaryButtonProps={{
        children: t('okay'),
        onClick: () => setIsOpen(false)
      }}
      title={t('shipmentTypeGptTitle')}
    >
      <S.ShipmentTypeModal>
        <Typography variant="body3">{t('shipmentTypeGptDescription')}</Typography>
        <ul style={{ margin: '16px 0' }}>
          {shipmentTypeGptList.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>

        <Notification
          message={<Trans i18nKey="shipmentTypeGptFooter" components={{ b: <b /> }} />}
          type="inline"
          status="warning"
        />
      </S.ShipmentTypeModal>
    </Modal>
  );
}

export { ShipmentTypeGptModal };

ShipmentTypeGptModal.propTypes = {
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func
};
